
import DoctorVisitsCharts from './component/DoctorVisitsCharts'

const DoctorVisits = () => {
  return (
    <>
      <DoctorVisitsCharts />
    </>
  )
}

export {DoctorVisits}
